import { EndpointBuilder } from '@reduxjs/toolkit/query';
import {
  FetchArgs,
  FetchBaseQueryError,
  FetchBaseQueryMeta
} from '@reduxjs/toolkit/query';
import { BaseQueryFn } from '@reduxjs/toolkit/query';
import { AllArrearConfigRecord } from '../../types/records/arrear-config';

export const prepaidConfigEndPoints = (
  builder: EndpointBuilder<
    BaseQueryFn<
      string | FetchArgs,
      unknown,
      FetchBaseQueryError,
      NonNullable<unknown>,
      FetchBaseQueryMeta
    >,
    string,
    'prepaidEngineApi'
  >
) => ({
  getAllArrears: builder.query<AllArrearConfigRecord[], string>({
    query: (param) => ({
      url: `/prepaid-engine/arrear_configuration/${param}`
    }),
    providesTags: ['getAllArrears']
  }),
  updateArrearDataBulk: builder.mutation<'', {data:Partial<AllArrearConfigRecord>[]}>({
    query: (data) => ({
      url: `/prepaid-engine/arrear_configuration/many/`,
      method: 'POST',
      body: data
    }),
    invalidatesTags: ['getAllArrears']
  }),
  deleteArrear: builder.mutation<'', number>({
    query: (id) => ({
      url: `/prepaid-engine/arrear_configuration/${id}`,
      method: 'DELETE'
    }),
    invalidatesTags: ['getAllArrears']
  })
});
